import { Box, Flex, font } from '@lemonade-hq/cdk';
import parse from 'html-react-parser';
import Image from 'next/image';
import styled from 'styled-components';
import type { PizzaMobileImages } from '../';
import { HOW_IT_WORKS_DEFAULTS } from '../defaults';

const MobilePizzaImage = styled(Image)`
  margin-top: 60px;
  pointer-events: none;
`;

const MobilePizzaText = styled(Box)`
  ${font('main', { fontSize: '2.0rem', lineHeight: '2.8rem' })};
  text-align: center;
  width: 220px;
  white-space: pre;
`;

interface PizzaMobileProps {
  readonly pizzaMobile: PizzaMobileImages;
}

const [pizza1Default, pizza2Default, pizza3Default] = HOW_IT_WORKS_DEFAULTS.pizzaMobile;
export const PizzaMobile: React.FC<PizzaMobileProps> = ({ pizzaMobile }) => {
  const [pizza1, pizza2, pizza3] = pizzaMobile;
  return (
    <Flex alignItems="center" flexDirection="column">
      <MobilePizzaImage alt="" height={165} loading="lazy" src={pizza1.image ?? pizza1Default.image} width={289} />
      <MobilePizzaText>{parse(pizza1.text)}</MobilePizzaText>
      <MobilePizzaImage
        alt="pizza slice image"
        height={196}
        loading="lazy"
        src={pizza2.image ?? pizza2Default.image}
        width={289}
      />
      <MobilePizzaText>{parse(pizza2.text)}</MobilePizzaText>
      <MobilePizzaImage
        alt="pizza slice image"
        height={165}
        width={289}
        loading="lazy"
        src={pizza3.image ?? pizza3Default.image}
      />
      <MobilePizzaText>{parse(pizza3.text)}</MobilePizzaText>
    </Flex>
  );
};
